import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

    getCookieValue(key: string): string {
        return solid.utils.getCookieValue(key);
    }

    setCookieValue(key: string, value: string, expireDate?: Date, path?: string): void {
        solid.utils.setCookieValue(key, value, expireDate, path);
    }

    deleteCookie(key: string, path?: string): void {
        solid.utils.deleteCookie(key, path);
    }

}